import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getEventLog(routeId) {
  const criteriaParams = {
    filters: [
      'id',
      'event.id',
      'event.description',
      'event.exibitionMode',
      'driver.name',
      'timeValuedTrue',
      'closed',
      'messageBody',
      'openedWhen',
      'equipment.description',
      'equipment.equipmentType.description'
    ],
    firstResult: 0,
    maxResults: 51
  };

  const payload = {
    criteriaChain: [
      {
        and: [
          { attr: 'closed', eq: false },
          { attr: 'route.id', eq: routeId },
          { attr: 'event.exibitionMode', neq: 'NOT_SHOW' }
        ]
      }
    ],
    sort: [{ attr: 'timeValuedTrue', type: 'DESC' }]
  };
  const url = `/EventLog/restrictions?criteria=${encodeURI(
    JSON.stringify(criteriaParams)
  )}`;

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export const queryKey = ['route-monitor-events'];

export function useEventLog(routeId) {
  return useQuery({
    queryKey,
    staleTime: 1000 * 60, // 1 min
    queryFn: async () => {
      if (routeId) {
        return getEventLog(routeId);
      }

      return [];
    }
  });
}
